import request from '@/utils/request'

// 打印机列表er
export const printer_list = (data) => {
    return request({
        url: '/erp/printers/index',
        method: 'get',
        data
    })
}

// 打印机状态
export const printer_Detail = (data) => {
  return request({
      url: '/erp/printers/get-config',
      method: 'get',
      data
  })
}

// 打印机添加或者修改printer
export const printer_set= (data) => {
    return request({
        url: '/erp/printers/set-config',
        method: 'post',
        data
    })
}

// 打印机删除
export const printer_del = (data) => {
    return request({
        url: '/erp/printers/del-config',
        method: 'post',
        data
    })
}